import { isDevMode } from "@angular/core";
import type { AuthPipe } from "@angular/fire/auth-guard";
import { AuthGuard, redirectLoggedInTo, redirectUnauthorizedTo } from "@angular/fire/auth-guard";
import type { Routes } from "@angular/router";

import { installPageGuard } from "./features/install/install-page.guard";

const redirectLoggedInToDashboard = (): AuthPipe => redirectLoggedInTo(["dashboard"]);
const redirectUnauthorizedToLogin = (): AuthPipe => redirectUnauthorizedTo(["login"]);

export const routes: Routes = [
    {
        path: "",
        redirectTo: "dashboard",
        pathMatch: "full"
    },
    {
        path: "configuration/:code",
        loadComponent: async () =>
            import("./features/setup-password/setup-password.component").then((m) => m.SetupPasswordComponent)
    },
    {
        path: "dashboard",
        loadComponent: async () => import("./features/dashboard/dashboard.component").then((m) => m.DashboardComponent),
        loadChildren: async () => import("./features/dashboard/dashboard.routes"),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectUnauthorizedToLogin }
    },
    {
        path: "design",
        loadComponent: async () => import("./features/design/design.component").then((m) => m.DesignComponent),
        canMatch: [() => isDevMode()]
    },
    {
        path: "forgot-password",
        loadComponent: async () =>
            import("./features/forgot-password/forgot-password.component").then((m) => m.ForgotPasswordComponent)
    },
    {
        path: "links",
        loadComponent: async () =>
            import("./features/landing-page/landing-page.component").then((m) => m.LandingPageComponent)
    },
    {
        path: "install",
        loadComponent: async () => import("./features/install/install.component").then((m) => m.InstallComponent),
        canActivate: [installPageGuard]
    },
    {
        path: "login",
        loadComponent: async () => import("./features/login/login.component").then((m) => m.LoginComponent),
        canActivate: [AuthGuard],
        data: { authGuardPipe: redirectLoggedInToDashboard }
    },
    {
        path: "privacy-policy",
        loadComponent: async () =>
            import("./features/privacy-policy/privacy-policy.component").then((m) => m.PrivacyPolicyComponent)
    },
    {
        path: "reset-password/:code",
        loadComponent: async () =>
            import("./features/reset-password/reset-password.component").then((m) => m.ResetPasswordComponent)
    }
];
